import React from "react";
import { Headline, Paragraph } from "./ui";

const HighlightBar = ({
  title = "HIGHLIGHTS",
  items = [
    "Sehr gepflegt",
    "Varioram",
    "Original",
    "Scheckheftgepflegt",
    "Unfallfrei",
    "Vollausstattung",
  ],
  backgroundColor = "var(--color-secondary-dark)",
  textColor = "var(--color-primary)",
  className = "",
  style = {},
  ...props
}) => {
  return (
    <div
      className={`relative z-20 rounded-md mx-4 p-4 sm:mx-32 sm:py-12 ${className}`}
      style={{
        backgroundColor: backgroundColor,
        ...style,
      }}
      {...props}
    >
      <div className="max-w-4xl mx-auto px-0">
        <Headline
          variant="h2"
          className="text-center font-bold mb-6"
          style={{ color: textColor }}
        >
          {title}
        </Headline>

        {/* List of highlights */}
        {items && items.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
            {items.map((item, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 py-3 rounded-sm md:flex-col md:items-center md:space-x-0 md:space-y-3"
              >
                <div className="flex-shrink-0 sm:w-10 sm:h-10 w-8 h-8 flex items-center justify-center bg-white rounded-full">
                  <svg
                    className="sm:w-7 sm:h-7 w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    style={{ color: textColor }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <Paragraph
                  variant="small"
                  className="font-bold md:text-center"
                  style={{ color: textColor }}
                  noSpacing
                >
                  {item}
                </Paragraph>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HighlightBar;
